import { Items } from '../../../shared/types/item'
import styles from './ItemThumbs.module.scss'

interface ItemThumbs {
  items?: Items
}

const ItemThumbs = (props: ItemThumbs) => {
  const { items } = props

  return (
    <div className={styles.itemThumbsRoot}>
      {Object.values({ ...items }).map((item, key) => (
        <div key={item.id}>{item.name}</div>
      ))}
    </div>
  )
}

export default ItemThumbs
